import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { DataBlockFormFields } from "@/features/datablocks/types/types";
import { FormFieldValue } from "@/domains/datablocks/types";
import { DataFieldResponse } from "@/redux/datablocks/types";

export const useDataBlockForm = (
  validationSchema: yup.ObjectSchema<DataBlockFormFields>,
) => {
  const form = useForm<DataBlockFormFields>({
    resolver: async (data, context, options) => {
      return yupResolver(validationSchema)(data, context, options);
    },
    mode: "onChange",
    reValidateMode: "onChange",
    defaultValues: {
      dataTemplate: undefined,
      request: undefined,
      sharingRights: undefined,
      fieldValues: [],
    },
  });

  const initializeFormFieldValues = (fields: DataFieldResponse[]) => {
    const fieldValues = fields.map((field) => ({
      field: field.id,
      value: undefined,
    }));
    form.setValue("fieldValues", fieldValues);
    return fieldValues;
  };

  const orderFieldValuesAccordingToTemplateFields = (
    orderedFieldIds: number[],
    fieldValues: FormFieldValue[],
  ) => {
    const fieldValueMap = new Map(
      fieldValues.map((item) => [item.field, item]),
    );

    return orderedFieldIds.map((fieldId) => {
      return (
        fieldValueMap.get(fieldId) || {
          field: fieldId,
          value: undefined,
        }
      );
    });
  };

  return {
    form,
    initializeFormFieldValues,
    orderFieldValuesAccordingToTemplateFields,
  };
};
